export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";